export default __webpack_public_path__ + "static/media/s1_female.59e878af.wav";